// src/api/driverDocumentApi.js
import axios from 'axios';
import { Platform } from 'react-native';

const API_BASE_URL = 'https://api.taxi-yaounde.com';
// const API_BASE_URL = 'http://localhost:4000'; 

export async function uploadDriverDocument(verificationId, personId, docType, file, docSide = 'front') {
  if (!verificationId) throw new Error('verificationId is required');
  if (!personId) throw new Error('personId is required');
  if (!docType) throw new Error('docType is required');
  if (!file) throw new Error('file is required');

  const url = `${API_BASE_URL}/api/verification/${verificationId}/driver-document`;

  const formData = new FormData();
  formData.append('personId', String(personId));
  formData.append('docType', docType);
  formData.append('docSide', docSide);

  if (Platform.OS === 'web') {
    if (file?.__webFile instanceof File) {
      formData.append('file', file.__webFile, file.__webFile.name);
    } else if (file instanceof File) {
      formData.append('file', file, file.name);
    } else if (file?.uri) {
      const res = await fetch(file.uri);
      const blob = await res.blob();
      const name = file.name || 'document';
      const type = file.mimeType || file.type || blob.type || 'application/octet-stream';
      const webFile = new File([blob], name, { type });
      formData.append('file', webFile, webFile.name);
    } else {
      throw new Error('Web upload: file must be a File or an object with { uri }');
    }

    const response = await axios.post(url, formData);
    return response.data;
  }

  if (!file?.uri) throw new Error('Native upload: file.uri is required');

  formData.append('file', {
    uri: file.uri,
    name: file.name || 'document',
    type: file.mimeType || file.type || 'application/octet-stream',
  });

  const response = await axios.post(url, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return response.data;
}

export async function getDriverDocuments(verificationId, personId) {
    if (!verificationId) throw new Error("verificationId is required");
    if (!personId) throw new Error("personId is required");

    const url = `${API_BASE_URL}/api/verification/${verificationId}/driver-documents/${personId}`;
    const response = await axios.get(url);
    return response.data;
}